<div>
  <div class="mx-auto" *ngIf="loadingEjecutor">
    <div class="d-flex justify-content-center">
      <strong>{{ inputMessageModal }}</strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ... 
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>
  <div *ngIf="!loadingEjecutor">
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
      <table datatable [dtTrigger]="dtTriggerEjecutor" class="table table-striped table-responsive">
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Nombre Ejecutor</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ejecutor of ejecutorMantenedor | paginate: {itemsPerPage : 10, currentPage: pageActualEjecutor}">
          <td class="td-centered">
            <!-- aca -->
            <span (click)="onCreateEjecutor(ejecutorModal,'Editar', ejecutor)" [ngbTooltip]="'Editar'">
              <img [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalEjecutor(confirmationModal, ejecutor)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{ejecutor.ejecutorDescription}}</td>
          <td class="td-centered">{{getEstadoLabel(ejecutor.status)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="pageActualEjecutor = $event" class="pagination"></pagination-controls>
  </div>
</div>

<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>
<!-- aca -->
<ng-template #ejecutorModal let-modal>
  <app-ejecutor-modal [modalCategoria]="modal" [mode]="creationMode" [categoria]="ejecutorSelected"
    (createEdit)="refreshEjecutorCreateOrUpdate($event)">
  </app-ejecutor-modal>
</ng-template>
